import React from 'react';
import { PricingHero } from '../components/pricing/PricingHero';
import { PricingTable } from '../components/pricing/PricingTable';
import { PricingQuestions } from '../components/pricing/PricingQuestions';
import { ServiceFaq } from '../components/ServiceFaq';
import { pricingPageFaqs } from '../data/faqs';
export function Pricing() {
  return <>
      <PricingHero data-id="element-732" data-mp="3v6ps01bq1pns" />
      <PricingTable data-id="element-733" data-mp="3r779tdbabson" />
      <ServiceFaq serviceName="Pricing" faqs={pricingPageFaqs} data-id="element-734" data-mp="3r7qie3f1p4q0" />
      <PricingQuestions data-id="element-735" data-mp="3r4ujabrgo9zz" />
    </>;
}